import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Fade from "@material-ui/core/Fade";
import LinearProgress from "@material-ui/core/LinearProgress";

const styles = theme => ({
  loadingContainer: {
    position: "absolute",
    width: "100%",
    top: 0,
    left: 0
  }
});

const OSSPageLoading = ({ isLoading, children, classes, inlineStyles }) => (
  <>
    <Fade in={isLoading} mountOnEnter unmountOnExit>
      <div className={classes.loadingContainer} style={inlineStyles}>
        <LinearProgress color="secondary" />
      </div>
    </Fade>

    <Fade in={!isLoading} timeout={150} unmountOnExit mountOnEnter>
      <div>{children}</div>
    </Fade>
  </>
);

OSSPageLoading.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  inlineStyles: PropTypes.object,
  isLoading: PropTypes.bool.isRequired
};
OSSPageLoading.defaultProps = {
  inlineStyles: {}
};

export default withStyles(styles)(OSSPageLoading);
